export enum AssessmentOutcome {
  // Live: the Company's parts as of this Assessment.
  COMPLETED = "completed",
  // Scored but never shown: an assessment-only Run, or a Compilation from
  // before live Files whose result was never published.
  ASSESSED = "assessed",
  FAILED = "failed",
}

export const dataByAssessmentOutcome: Record<
  AssessmentOutcome,
  { label: string }
> = {
  [AssessmentOutcome.COMPLETED]: { label: "Completed" },
  [AssessmentOutcome.ASSESSED]: { label: "Assessed, not shown" },
  [AssessmentOutcome.FAILED]: { label: "Failed" },
}

// The outcomes a buyer sees.
export const liveAssessmentOutcomes = [AssessmentOutcome.COMPLETED]

// The outcomes that scored the Company, shown or not.
export const scoredAssessmentOutcomes = [
  AssessmentOutcome.COMPLETED,
  AssessmentOutcome.ASSESSED,
]
